exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_object-pie.js
// module id = 631
// module chunks = 27